import {useEffect,useState} from 'react'
//import {UserEditModalHeader} from './UserEditModalHeader'
//import {UserEditModalFormWrapper} from './UserEditModalFormWrapper'
import { ViewModalHeader } from './ViewModalHeader'
import axios from 'axios'
import { Card4 } from '../../../../../../_metronic/partials/content/cards/Card4'
import { getPermisoId, getPermisoIdGlobal, getpermisosDisponiblesGlobal } from '../request/request'
import Swal from 'sweetalert2'
import { getpermisosDisponibles } from '../request/request'
import { useAuth } from '../../../../auth'
import { useAppSelector } from '../../../../../../redux/hooks'
const API_URL = process.env.REACT_APP_API_URL


type Rol=
  {
  name:string
  description:string
  id:string
  Permissions:x[]

 

  }
type x=
{
  id: string
  name:string
  description:string
}



const RolesUpdateCreate = ( props:any ) => {
  /*********************************Constantes**************************************** */
  const tenant= useAppSelector(state =>state.TenantSlice.id)

  const{currentUser}= useAuth()
  const[PermisosDisp, setPermisoDisp]=useState<x[]>([])
  const [selectedItems, setSelectedItems] = useState<number[]>([]);


  const [IdPermiso,setIdPermiso]= useState<Rol>({
    name:'',
    description:'',
    id:'',
    Permissions:[]
   
  })


  // eslint-disable-next-line
  const [loading, setLoading] = useState(false)

  ////
  const [Nombre,setNombre] = useState('');
  const [Description,setDescription] = useState('');


  

  /************************************llamadas a la API ********************************************** */

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  useEffect(() => {
    //colocar llamada al ep de ticket for id 
    const fetchData = async () => {
      try {
        if( props.id !== ""&& props.id !=="adminrol"   ){
          if (currentUser?.ListPermiso?.includes('Roles.Update')){
            if(tenant===0){
              const UserResponse = await getPermisoId(props.id);
              setIdPermiso(UserResponse.data);
              const permisosupdate= []
              for (const a of UserResponse.data.Permissions){
                permisosupdate.push(a.id)
              }
              setSelectedItems(permisosupdate)
            }
            else if(tenant!==0){
              const UserResponse = await getPermisoIdGlobal(props.id,tenant);
              setIdPermiso(UserResponse.data);
              const permisosupdate= []
              for (const a of UserResponse.data.Permissions){
                permisosupdate.push(a.id)
              }
              setSelectedItems(permisosupdate)
            }
          }
      }
      } catch (error) {
        console.error('Error al obtener los permisos', error);
      }
       };
  
      fetchData();
  }, [props.id])


  useEffect(() => {
    //se llama al ep de permisos 
    const fetchData = async () => {
      try {
        if(tenant===0){
          const permisos = await getpermisosDisponibles();
          setPermisoDisp(permisos.data)
        }
        else{
          const permisos = await getpermisosDisponiblesGlobal(tenant);
          setPermisoDisp(permisos.data)
        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
       };
  
      fetchData();
  }, [props.id])


  


  /************************************************************************* */
  

    //const navigate = useNavigate();

    const handleSubmit =async (e:any) => {
    e.preventDefault();

    try{
      const permision= []
      for (const y of selectedItems){
        permision.push({id:y})
      }
      
      
      
      if(props.id !==null){
        const actualizar={
          name:IdPermiso.name,
          description:IdPermiso.description,
          id:IdPermiso.id,
          Permission: permision
        }
       if (tenant===0){ 
          await axios.put(API_URL+'/v1/rol/'+props.id, actualizar)
          .then(res=>{ Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Your Role has Update',
            showConfirmButton: false,
            timer: 1500
          })
          window.location.reload();
        });
        }
        else{
          await axios.put(API_URL+'/v1/rol/'+props.id+'?tenantId='+tenant, actualizar)
          .then(res=>{ Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Your Role has Update',
            showConfirmButton: false,
            timer: 1500
          })
          window.location.reload();
        });
        }
      
      }

      else{
        const body ={
          name:Nombre,
          description:Description,
          Permission:permision,
        }
        if(tenant===0){
        await axios.post(API_URL+'/v1/rol/', body)
        .then(res=>{ Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Your Role has created',
          showConfirmButton: false,
          timer: 1500
        
        })
        window.location.reload();

      });
      }
      else{
        await axios.post(API_URL+'/v1/rol/?tenantId='+tenant, body)
        .then(res=>{ Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Your Role has created',
          showConfirmButton: false,
          timer: 1500
        })
        window.location.reload();
      });
      }
      //navigate('/support/SeeRequest')
    }
  }
    catch(error:any){
      console.log(error)

    }

    
   }

  

  ///////////////////////////////////////////////

  

    useEffect(() => {
      console.log(selectedItems)
    }, [selectedItems])
  
  

    const handleCheckboxChange = (event:any) => {
        const { value, checked } = event.target;
        
        if (checked) {
            setSelectedItems((prevSelectedItems:Array<number>) => [...prevSelectedItems, Number(value)]);
        } else {
            setSelectedItems((prevSelectedItems:Array<number>) =>
                prevSelectedItems.filter((item) => item !== Number(value))
            );
        }
    };

   



   

  return (
    
    <>
    {props.id !==null && props.id!=='adminrol'&&
    <div>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <ViewModalHeader setID={props.setID} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
            <form className='form w-100' id='kt_login_signin_form' onSubmit={handleSubmit} >
                                {/* begin::Heading */}
                               {/* <Card4
                                icon='/media/svg/files/NubeTD.svg'
                                title=' '
                        description=''></Card4>*/}
                                <div className='text-center mb-5'>
                                <h1 className='text-dark fw-bolder mb-3 f-titulo fs-md'>Edit Rol</h1>
                                </div>
                                {/* begin::Heading */}
                        
                                {/* begin::Login options */}

                                <div className='mb-2 bg-light-info p-8 rounded f-parrafo'>
                                    <div className='text-info'>
                                  
                                  Use this section to  <strong>Edit</strong> role data.
                                    </div>
                                </div>
                               
                                {/* Campos solicitud */}
                                <div>
                                   <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="name">Name</label>
                                   <input type="text" name='name' value={IdPermiso.name}className='form-control form-control-solid border-gray-300 f-parrafo' 
                                   onChange={(e:any) => setIdPermiso({...IdPermiso,name: e.target.value})}/>
                                </div>
                                <div>
                                   <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="apellido">Description</label>
                                   <input type="text" name='apellido' value={IdPermiso.description}className='form-control form-control-solid border-gray-300 f-parrafo' 
                                   onChange={(e:any) => setIdPermiso({...IdPermiso,description: e.target.value})}/>
                                </div>
                              
                                <br />
                                <p className='form-label fw-bolder text-marino f-parrafo  text-center fs-3 mb-0' >Permissions</p>
                                <br />
                                <div className="card-body card-scroll h-200px">
                                  {IdPermiso.Permissions.length !== 0 && PermisosDisp.map((perm:any)=>(
                                    <>
                                  <label className='form-check form-check-custom form-check-solid align-items-start'>
                                    <input
                                      className='form-check-input me-3 border border-azul'
                                      type='checkbox'
                                      name='email-preferences[]'   
                                      value={perm.id}     
                                      onChange={handleCheckboxChange} 
                                      defaultChecked={selectedItems.includes(perm.id)} 
                                      
                                    />

                                    <span className='form-check-label d-flex flex-column align-items-start'>
                                      <span className='fw-bolder text-dark fs-5 mb-0 f-parrafo'>{perm.name}</span>
                                      <span className='text-muted fs-6 f-parrafo'>
                                        {perm.description}
                                      </span>
                                    </span>
                                  </label>
                                  <div className='separator separator-dashed my-6'></div>
                                  </>))}

                                      
                                      </div>
                                      <br />

                                 {/* begin::Action */}
                                 <div className='d-grid mb-10 justify-content-center'>
                                  <div className='row'>
                                      <div className='col'>
                                        <button
                                        type='submit'
                                        id='kt_sign_in_submit'
                                        className='btn btn-primary'                                                                        
                                        >
                                          {!loading && <span className='indicator-label'>Save</span>}
                                          {loading && (
                                            <span className='indicator-progress' style={{display: 'block'}}>
                                            Please wait...
                                              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                            </span>
                                          )}
                                        </button>

                                      </div>
                                      <div className='col'>
                                        <button
                                         className='btn border border-pink text-pink f-parrafo'
                                         style={{width:'200px'}}
                                        onClick={() => props.setID(undefined)}

                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    
                                  </div>
                                  
                                </div>
                                {/* end::Action */}

                                
                            </form>
                            
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
      </div>
      }

{props.id==='adminrol'&&
    <div>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <ViewModalHeader setID={props.setID} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
            <form className='form w-100' id='kt_login_signin_form' onSubmit={handleSubmit} >
                                {/* begin::Heading */}
                               {/* <Card4
                                icon='/media/svg/files/NubeTD.svg'
                                title=' '
                        description=''></Card4>*/}
                                <div className='text-center mb-5'>
                                <h1 className='text-dark fw-bolder mb-3 f-titulo fs-md'>View Rol</h1>
                                </div>
                                {/* begin::Heading */}
                        
                                {/* begin::Login options */}

                               
                               
                                {/* Campos solicitud */}
                                <div>
                                   <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="name">Name</label>
                                   <input type="text" name='name' value={'Admin'}className='form-control form-control-solid border-gray-300 f-parrafo' 
                                   />
                                </div>
                                <div>
                                   <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="apellido">Description</label>
                                   <input type="text" name='apellido' value={'Admin'}className='form-control form-control-solid border-gray-300 f-parrafo' 
                                   />
                                </div>
                              
                                <br />
                                <p className='form-label fw-bolder text-marino f-parrafo  text-center fs-3 mb-0' >Permissions</p>
                                <br />
                                <div className="card-body card-scroll h-200px">
                                  { PermisosDisp.map((perm:any)=>(
                                    <>
                                  <label className='form-check form-check-custom form-check-solid align-items-start'>
                                    <input
                                      className='form-check-input me-3 border border-azul'
                                      type='checkbox'
                                      name='email-preferences[]'   
                                      value={perm.id}     
                                      onChange={handleCheckboxChange} 
                                      checked
                                      
                                    />

                                    <span className='form-check-label d-flex flex-column align-items-start'>
                                      <span className='fw-bolder text-dark fs-5 mb-0 f-parrafo'>{perm.name}</span>
                                      <span className='text-muted fs-6 f-parrafo'>
                                        {perm.description}
                                      </span>
                                    </span>
                                  </label>
                                  <div className='separator separator-dashed my-6'></div>
                                  </>))}

                                      
                                      </div>
                                      <br />

                                 {/* begin::Action */}
                                 <div className='d-grid mb-10 justify-content-center'>
                                  <div className='row'>
                                    
                                      <div className='col'>
                                        <button
                                         className='btn border border-pink text-pink f-parrafo'
                                         style={{width:'200px'}}
                                        onClick={() => props.setID(undefined)}

                                        >
                                          Close
                                        </button>
                                      </div>
                                    
                                  </div>
                                  
                                </div>
                                {/* end::Action */}

                                
                            </form>
                            
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
      </div>
      }



      {props.id === null && props.id!=='adminrol'&&
      <div>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <ViewModalHeader setID={props.setID} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
            <form className='form w-100' id='kt_login_signin_form' onSubmit={handleSubmit} >
                                {/* begin::Heading */}
                                {/*<Card4
                                icon='/media/svg/files/NubeTD.svg'
                                title=' '
      description=''></Card4>*/}
                                <div className='text-center mb-5'>
                                <h1 className='text-marino fw-bolder mb-3 f-titulo fs-md'>Add Role</h1>
                                </div>
                                {/* begin::Heading */}
                        
                                {/* begin::Login options */}

                                <div className='mb-2 bg-light-info p-8 rounded f-parrafo'>
                                    <div className='text-info'>
                                        Use this section to  <strong>Add</strong> Roles.
                                    </div>
                                </div>
                               
                                {/* Campos solicitud */}
                                <div>
                                   <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="name">Name</label>
                                   <input type="text" 
                                   name='name' 
                                   className='form-control form-control-solid border-gray-300 f-parrafo' 
                                   id='Nombre'
                                   value={Nombre}
                                   onChange={(e:any) => setNombre(e.target.value)}
                                   />
                                </div>
                                <div>
                                   <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="descripcion">Description</label>
                                   <input type="text" 
                                   name='name' 
                                   className='form-control form-control-solid border-gray-300 f-parrafo' 
                                   id='descripcion'
                                   value={Description}
                                   onChange={(e:any) => setDescription(e.target.value)}
                                   />
                                </div>
                                <br />
                                <p className='form-label fw-bolder text-marino  text-center fs-3 mb-0 f-parrafo' >Permissions</p>
                                <br />
                                <div className="card-body card-scroll h-200px">
                                {PermisosDisp.map((perm:any)=>(
                                  <>
                                <label className='form-check form-check-custom form-check-solid align-items-start'>
                                  <input
                                    className='form-check-input me-3 border border-azul'
                                    type='checkbox'
                                    name='email-preferences[]'   
                                    value={perm.id}     
                                    onChange={handleCheckboxChange}  
                                  />

                                  <span className='form-check-label d-flex flex-column align-items-start'>
                                    <span className='fw-bolder text-dark fs-5 mb-0 text-parrafo'>{perm.name}</span>
                                    <span className='text-muted fs-6 text-parrafo'>
                                      {perm.description}
                                    </span>
                                  </span>
                                </label>
                                <div className='separator separator-dashed my-6'></div>
                                </>))}

                                    
                                    </div>
                                      {/* end::Label */}
                                    {/* end::Radio */}

                                {/* begin::Action */}
                                <br />
                                <div className='d-grid mb-10 justify-content-center'>

                                  <div className='row'>
                                    <div className='col'>
                                      <button
                                          type='submit'
                                          id='kt_sign_in_submit'
                                          className='btn btn-primary'
                                  
                                          
                                        >
                                          {!loading && <span className='indicator-label'>Save</span>}
                                          {loading && (
                                            <span className='indicator-progress' style={{display: 'block'}}>
                                            Please wait...
                                              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                            </span>
                                          )}
                                        </button>
                                    </div>
                                    <div className='col'>
                                        <button
                                         className='btn border border-pink text-pink f-parrafo'
                                         style={{width:'200px'}}
                                        onClick={() => props.setID(undefined)}

                                        >
                                          Cancel
                                        </button>
                                      </div>
                                  </div>
                                  
                                  
                                </div>
                                {/* end::Action */}

                            </form>
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
      </div>
      }   
      
    </>
  )
}
export {RolesUpdateCreate}